import { IRequesterInfo } from "../../../../base/models"
import { ClientProxy } from "../../../../base/proxy/clientProxy"

export class CancelOrderApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'MyReports/cancelPreOrder',
      requesterInfo,
    })
  }

  public async cancelOrder(request: number[]): Promise<any> {
    return await this.postAsync<any>(request)
  }
}
